import Image from 'next/image'

import { PhnxButton } from '../Button/Button'
import styles from './Avatar.module.css'

export type AvatarProps = {
  asset: {
    src: string
    alt: string
  }
  size: 'default' | 'small' | 'large' | 'medium' | 'extralarge'
  style: 'circle' | 'square' | 'feature'
  title?: string
  subtitle?: string
  link?: string
}

export const PhnxAvatar: React.FC<AvatarProps> = ({
  asset,
  size = 'default',
  style = 'circle',
  title,
  subtitle,
  link,
}) => {
  let height = 48
  let width = 48

  if (size === 'small') {
    height = 38
    width = 38
  }

  if (size === 'medium') {
    height = 78
    width = 78
  }

  if (size === 'large') {
    height = 120
    width = 120
  }

  if (size === 'extralarge') {
    height = 160
    width = 160
  }

  if (style === 'feature') {
    height = 500
    width = 500
  }

  // build the new URL and enable the image service
  let imgUrl
  if (asset.src.includes('storyblok')) {
    imgUrl = `${asset.src}/m/${width}x${height}/smart/filters:quality(100)`
  } else {
    imgUrl = `${asset.src}`
  }
  return (
    <div
      className={`${styles[`style-${style}`]} ${styles[`size-${size}`]}`}
      data-testid="avatar"
      data-test-style={style}
      data-test-size={size}
      style={style === 'feature' ? { width: '100%' } : { width, height }}
    >
      {asset.src && (
        <Image src={`${imgUrl}`} alt="avatar" width={height} height={width} quality={100} />
      )}
      {title && (
        <div>
          <h4 className={styles['avatar-title']}>{title}</h4>
        </div>
      )}
      {subtitle && <div className={styles['avatar-subtitle']}>{subtitle}</div>}
      {link && (
        <div className={styles['avatar-btn']}>
          <PhnxButton type="link" href={link} variant="tertiary" label="View Profile" />
        </div>
      )}
    </div>
  )
}
